$(document).on('dblclick', '[data-instant-search]', (event) => {
  event.target.select();
});

$(document).on('open.zf.reveal', '[data-reveal]', function() {
  const $searchTableInput = $(this).find('input[data-search-table]');
  if ($searchTableInput.length) {
    $searchTableInput.focus();
  }
});

$(document).ready(() => {
  const $searchTableInput = $('input[data-search-table]').first();
  if ($searchTableInput.length) {
    $searchTableInput.focus();
  } else {
    $('[data-instant-search][value=""]').focus();
  }
});
